import { animated, config, useTransition } from '@react-spring/web';
import { MouseEvent } from 'react';
import EnergyGuzzlersQuizSuccess from '../EnergyGuzzlersQuizSuccess/EnergyGuzzlersQuizSuccess';
import styles from './EnergyGuzzlersQuiz.module.scss';
import EnergyGuzzlersQuizContent from './EnergyGuzzlersQuizContent/EnergyGuzzlersQuizContent';
import EnergyGuzzlersQuizSavingsCounter from './EnergyGuzzlersQuizSavingsCounter/EnergyGuzzlersQuizSavingsCounter';
import useQuiz from './hooks/useQuiz';

const EnergyGuzzlersQuiz = () => {
  const {
    currentEnergyGuzzlerIndex,
    energyGuzzlers,
    gotoNextEnergyGuzzler,
    isFinished,
    isValidAnswer,
    restartQuiz,
    savingsAmount,
    cheatQuiz,
  } = useQuiz();

  const transition = useTransition(currentEnergyGuzzlerIndex, {
    from: {
      transform: 'translateX(-100%)',
      opacity: 0,
    },
    enter: {
      transform: 'translateX(0%)',
      opacity: 1,
    },
    leave: {
      transform: 'translateX(100%)',
      opacity: 0,
    },
    config: config.stiff,
    exitBeforeEnter: true,
  });

  const handleClick = (event: MouseEvent) => {
    if (event.altKey) {
      cheatQuiz();
    }
  };

  return (
    <div className={styles.base} onClick={handleClick}>
      {transition((style, i) => {
        const energyGuzzler = energyGuzzlers[i];
        const element =
          energyGuzzler.type === 'question' ? (
            <EnergyGuzzlersQuizContent
              energyGuzzler={energyGuzzler}
              gotoNextEnergyGuzzler={gotoNextEnergyGuzzler}
              isValidAnswer={isValidAnswer}
              step={currentEnergyGuzzlerIndex}
              key={i}
            />
          ) : (
            <EnergyGuzzlersQuizSuccess savingsAmount={savingsAmount} key={i} />
          );
        return <animated.div style={style}>{element}</animated.div>;
      })}
      <EnergyGuzzlersQuizSavingsCounter
        savingsAmount={savingsAmount}
        step={currentEnergyGuzzlerIndex + 1}
        onRestartQuiz={restartQuiz}
        showRestartButton={isFinished}
      />
    </div>
  );
};

export default EnergyGuzzlersQuiz;
